import React, {createContext, useContext, useRef} from "react";

const NotificationContext = createContext(null);

export function useNotificationContext() {
    const context = useContext(NotificationContext);
    if(!context) {
        throw new Error('useNotificationContext must be used within NotificationProvider');
    }

    return context;
}

export function NotificationProvider(props) {
    const toast = useRef(null);
    const value = {toast};

    return <NotificationContext.Provider value={value} {...props}/>
}